import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

const getIvrTableState = (state: RootState) => state.ivrTable;

export const getIvrTableStatusCodeSelector = createSelector(
  [getIvrTableState],
  (ivrTable) => ivrTable?.statusCode,
);

export const getIvrTableMessageSelector = createSelector(
  [getIvrTableState],
  (ivrTable) => ivrTable?.message,
);

export const getIvrTableStatusSelector = createSelector(
  [getIvrTableState],
  (ivrTable) => ivrTable?.status,
);
